( function( $ ){

  const $body = $( 'body' );
  const $header = $( '#site-header' );
  const $menu = $( '#menu-wrap' );
  const $toggle = $( '#mobile-menu-toggle' );
  const speed = 300;
  const scroll_delta_threshold = 8;
  const scroll_hide_offset = 140;

  const menu_bp = $header.data( 'menu-bp' );
  let last_scroll_y = window.scrollY;
  let ticking = false;
  let breakpoint_transition_timeout = null;


  function pause_breakpoint_transitions () {
    window.clearTimeout( breakpoint_transition_timeout );
    $header.addClass( 'breakpoint-switching' );
    $menu.removeClass( 'mobile-transition-enabled' );

    breakpoint_transition_timeout = window.setTimeout( function () {
      $header.removeClass( 'breakpoint-switching' );
      $menu.addClass( 'mobile-transition-enabled' );
    }, speed );
  }


  function is_mobile () {
    return $toggle.is( ':visible' );
  }


  // create focus trap
  const focus_trap = focusTrap.createFocusTrap( $header.get(0), {
    onActivate () {
      $toggle.addClass( 'is-active' );
      $menu.addClass( 'visible' );
      $body.addClass( 'menu-open' );
    },
    onDeactivate () {
      $toggle.removeClass( 'is-active' );
      $body.removeClass( 'menu-open' );
      setTimeout( function () {
        $menu.removeClass( 'visible' );
      }, speed );
    },
    initialFocus: $toggle.get(0),
  });


  function resize () {
    const next_is_mobile = !ThemeJS.Media_Queries.is_at_least( menu_bp );
    const mode_changed = $header.hasClass( 'mobile' ) !== next_is_mobile;

    if ( mode_changed ) {
      pause_breakpoint_transitions();
    }

    $header.toggleClass( 'mobile', next_is_mobile );
    document.querySelector( ':root' ).style.setProperty( '--header-height', `${ $header.outerHeight() }px` );

    if ( !mode_changed ) {
      $menu.addClass( 'mobile-transition-enabled' );
    }

    if ( ThemeJS.Media_Queries.is_at_least( menu_bp ) ) {
      focus_trap.deactivate();
      $( 'button.sub-menu-toggle' ).closest( 'li' ).each( function () {
        set_submenu_open( $(this), false );
      });
    }
    sync_header_visibility();
  }


  function sync_header_visibility () {
    let current_scroll_y = window.scrollY;
    let scroll_diff = current_scroll_y - last_scroll_y;
    let near_top = current_scroll_y <= scroll_hide_offset;
    let should_hide = false;

    if ( near_top || $body.hasClass( 'menu-open' ) ) {
      $header.removeClass( 'header-hidden' );
      last_scroll_y = current_scroll_y;
      ticking = false;
      return;
    }

    if ( Math.abs( scroll_diff ) < scroll_delta_threshold ) {
      ticking = false;
      return;
    }

    should_hide = scroll_diff > 0;
    $header.toggleClass( 'header-hidden', should_hide );
    last_scroll_y = current_scroll_y;
    ticking = false;
  }


  function on_scroll () {
    if ( ticking ) {
      return;
    }
    ticking = true;
    window.requestAnimationFrame( sync_header_visibility );
  }


  // init header pad height and set header to fixed
  resize();
  $header.addClass( 'fixed' );
  // trigger height recalculation on breakpoint change
  $( window ).on( 'breakpoint_changed', resize );
  window.addEventListener( 'scroll', on_scroll, { passive: true } );

  // toggle mobile menu on hamburger click
  $toggle.click( () => {
    $body.hasClass( 'menu-open' ) ? focus_trap.deactivate() : focus_trap.activate();
  });


  // function to set submenus open/close
  function set_submenu_open ( $li, opening ) {
    let $btn = $( '> .link-wrap button.sub-menu-toggle', $li );
    if ( !$btn.length ) { return; }
    let $submenu = $( `#${ $btn.attr( 'aria-controls' ) }` );
    if ( !$submenu.length ) { return; }
    $btn.attr( 'aria-expanded', opening ? 'true' : 'false' );
		$submenu.attr( 'aria-hidden', opening ? 'false' : 'true' )[ opening ? 'slideDown' : 'slideUp' ]( speed );
  }


  // toggle submenus on click of caret btns
  $menu.on( 'click', 'button.sub-menu-toggle', function () {
    set_submenu_open( $(this).closest( 'li' ), $(this).attr( 'aria-expanded' ) == 'false' );
  });


  // close submenu on tab out
  $menu.on( 'focusout', 'li.menu-item-has-children', function ( e ) {
    if ( is_mobile() || $.contains( this, e.relatedTarget ) ) { return; }
    set_submenu_open( $(this), false );
  });


  // treat click of a custom link '#' menu item as clicking its submenu toggle
  $menu.on( 'click', 'a[href="#"]', function ( e ) {
    e.preventDefault();
    let $btn = $( '+ .sub-menu-toggle', this );
    if ( $btn.length ) {
      $btn.click();
    }
  });

  // Industries mega Tab View — swap child panels on parent tab hover/focus.
  // Click still follows the parent page link.
  $menu.on('mouseenter focusin', '.mega-menu--tabs .mega-tab', function () {
    if (is_mobile()) {
      return;
    }

    const $tab = $(this);
    const panelId = $tab.attr('data-mega-tab-panel');
    const $tabsRoot = $tab.closest('.mega-tabs');
    if (!panelId || !$tabsRoot.length) {
      return;
    }

    $tabsRoot.find('.mega-tab-item').removeClass('is-active');
    $tabsRoot.find('.mega-tab').removeAttr('aria-current');
    $tab.closest('.mega-tab-item').addClass('is-active');
    $tab.attr('aria-current', 'true');

    $tabsRoot.find('.mega-tabs-panel').removeClass('is-active').attr('hidden', true);
    $tabsRoot.find('#' + panelId).addClass('is-active').removeAttr('hidden');
  });

})( jQuery );
